import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 16,
            padding: 24,
            background: '#0a0a0a',
            color: '#efefef',
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: 18, letterSpacing: '0.1em', textTransform: 'uppercase' }}>
            Ошибка загрузки
          </div>
          <div style={{ fontSize: 13, color: '#4a4a4a', maxWidth: 420, wordBreak: 'break-word' }}>
            {String(this.state.error?.message || this.state.error)}
          </div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              height: 46,
              padding: '0 16px',
              background: '#0e0e0e',
              border: '1px solid #7c9178',
              color: '#7c9178',
              fontFamily: 'inherit',
              fontSize: 16,
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            Обновить страницу
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
